<div class="summary-tab flex-row-wrap">
  <div class="left-column">
    <rn-expansion-panel>
      <h4 expansionHeader>Description</h4>
      <ng-container>
        <rn-show-more-section [maxHeight]="150">
          @if (metadata?.summary) {
            <span #showMoreContent [innerHTML]="metadata.summary"></span>
          } @else if (catalogRecord?.description) {
            <span #showMoreContent [innerHTML]="catalogRecord.description"></span>
          } @else {
            <span #showMoreContent>No description provided</span>
          }
        </rn-show-more-section>
      </ng-container>
    </rn-expansion-panel>
    @if (catalogRecord && catalogRecord.marcDetails) {
      <rn-expansion-panel>
        <h4 expansionHeader>Item Details</h4>
        <ng-container *ngTemplateOutlet="detailsBody; context: {catalogRecord: catalogRecord}"/>
      </rn-expansion-panel>
    }
  </div>
</div>

<ng-template #detailsBody let-catalogRecord="catalogRecord">
  <div class="details-body">
    <table class="details-table">
      <caption style="display: none;">Catalog Item Details</caption>
      <tr style="display: none;">
        <th>Detail Field</th>
        <th>Detail Value</th>
      </tr>
      <!-- Material Type Match -->
      <tr>
        <td>Format:</td>
        <td>{{ catalogRecord.materialType.description }}</td>
      </tr>
      <tr>
        <td class="title">Title:</td>
        <td>{{ catalogRecord.marcDetails.title }}</td>
      </tr>
      <tr>
        <td>Author:</td>
        <td><a [queryParams]="{filterLinkType: 'author', filterLinkValue: catalogRecord.marcDetails.author}"
               routerLink="/catalog-browse">{{ catalogRecord.marcDetails.author }}</a>
        </td>
      </tr>
      <tr>
        <td>Edition:</td>
        @if (catalogRecord.marcDetails.edition) {
          <td>{{ catalogRecord.marcDetails.edition }}</td>
        } @else {
          <td>Not available</td>
        }
      </tr>
      <tr>
        <td>Publisher, Date:</td>
        @if (catalogRecord.marcDetails.publisher || catalogRecord.marcDetails.publicationDate) {
          <td>{{ catalogRecord.marcDetails.publisher }} {{ catalogRecord.marcDetails.publicationDate }}</td>
        } @else {
          <td>Not available</td>
        }
      </tr>
      <tr>
        <td>Description:</td>
        <td>{{ catalogRecord.marcDetails.physicalDescription || 'Not available' }}</td>
      </tr>
      <!-- Must track by $index because subjects could contain duplicate strings. -->
      @for (s of catalogRecord.marcDetails.subjects; track $index) {
        <tr>
          @if ($first) {
            <td>Subjects:</td>
            <td><a [queryParams]="{filterLinkType: 'subject', filterLinkValue: s}" routerLink="/catalog-browse">{{ s }}</a></td>
          } @else {
            <td></td>
            <td><a [queryParams]="{filterLinkType: 'subject', filterLinkValue: s}" routerLink="/catalog-browse">{{ s }}</a></td>
          }
        </tr>
      }
      <!-- Must track by $index because genres could contain duplicate strings. -->
      @for (s of catalogRecord.marcDetails.genres; track $index) {
        <tr>
          @if ($first) {
            <td>Genres:</td>
            <td><a [queryParams]="{filterLinkType: 'genre', filterLinkValue: s}" routerLink="/catalog-browse">{{ s }}</a></td>
          } @else {
            <td></td>
            <td><a [queryParams]="{filterLinkType: 'genre', filterLinkValue: s}" routerLink="/catalog-browse">{{ s }}</a></td>
          }
        </tr>
      }
      @if (catalogRecord.marcDetails.identifiers) {
        <!-- Must track by $index because ISBNs could contain duplicate strings. -->
        @for (s of catalogRecord.marcDetails.identifiers['isbn']; track $index) {
          <tr>
            @if ($first) {
              <td>ISBN:</td>
              <td>{{ s }}</td>
            } @else {
              <td></td>
              <td>{{ s }}</td>
            }
          </tr>
        }
      }
    </table>
  </div>
</ng-template>
